module.exports = __webpack_public_path__ + "static/face-3cdbd957860e1d30537dd9f579295657.jpg";